"use client";
import { toggleMobileMenu } from "@/utlis/toggleMobileMenu";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { init_classic_menu_resize } from "@/utlis/menuToggle";
import { scrollToElement } from "@/utlis/scrollToElement";
import useIsMobile from '@/app/api/useisMobile';
import { HomeHeaderData } from "@/data/menu";
import ProductHeader from "./Products/ProductHeader";

export default function HeaderPreview({ productmenuinmobile }) {

  const [menuOpen, setMenuOpen] = useState([-1, -1]);
  const [selectedProduct, setSelectedProduct] = useState(HomeHeaderData.products.items[0]);
  const isMobile = useIsMobile();

  const toggleParent = (level, index) => {
    const temp = [...menuOpen];
    temp[level] = temp[level] === index ? -1 : index;
    setMenuOpen(temp);
  };

  useEffect(() => {
    setTimeout(scrollToElement, 1000);
    init_classic_menu_resize();
    window.addEventListener("resize", init_classic_menu_resize);
    return () => window.removeEventListener("resize", init_classic_menu_resize);
  }, []);

  return (
    <div className="main-nav-sub full-wrapper ">
      {isMobile ? (
        <>
          <Link href={HomeHeaderData.brand.homepage_link || "/"}>
            <div className="nav-logo-wrap local-scroll">
              <Image src={HomeHeaderData.brand.logo} alt={HomeHeaderData.brand.website_name} width={205} height={34} priority style={{ width: "auto", height: "auto", maxHeight: "40px" }} />
            </div>
          </Link>
          <div onClick={toggleMobileMenu} className="mobile-nav" role="button" tabIndex={0}>
            <i className="mobile-nav-icon" />
            <span className="visually-hidden">Menu</span>
          </div>
        </>
      ) : (
        <div onClick={toggleMobileMenu} className="mobile-nav" role="button" tabIndex={0}>
          <i className="mobile-nav-icon" />
          <span className="visually-hidden">Menu</span>
        </div>
      )}

      {isMobile && productmenuinmobile &&
        <ProductHeader data={productmenuinmobile} />
      }

      <div className="inner-nav desktop-nav">
        <ul className="clearlist local-scroll justify-content-start">
          {!isMobile && (
            <li style={{ marginRight: '90px' }}>
              <Link href={HomeHeaderData.brand.homepage_link || "/"}>
                <Image src={HomeHeaderData.brand.logo} alt={HomeHeaderData.brand.website_name} width={184} height={66} style={{ width: "auto", height: "auto", maxHeight: "64px" }} />
              </Link>
            </li>
          )}

          {/* PRODUCTS */}
          {/* {isMobile ?
            <>
              {HomeHeaderData.products.items.length > 0 && (
                <li className={menuOpen[1] === 1 ? "js-opened" : ""}>
                  <a href="#" onClick={() => toggleParent(1, 1)} className="mn-has-sub" aria-label="Product">
                    {HomeHeaderData.products.title} <i className="mi-chevron-down" />
                  </a>
                  <ul className={`mn-sub mn-has-multi ${menuOpen[1] === 1 ? "mobile-sub-active" : ""}`}>
                    <li
                      className="mn-sub-multi"
                      style={{
                        minWidth: "250px",
                        marginLeft: "-30%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <ul>
                        {HomeHeaderData.products.items.map((product, index) => (
                          <li key={index}>
                            <a href={product.link} aria-label={product.title}>
                              {product.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </li>
              )
              }
            </>
            :
          } */}
          <li className={menuOpen[1] === 1 ? "js-opened" : ""}>
            <a href="#" onClick={() => toggleParent(1, 1)} className="mn-has-sub" aria-label="Products">
              {HomeHeaderData.products.title} <i className="mi-chevron-down" />
            </a>
            <ul className={`mn-sub mn-has-multi ${menuOpen[1] === 1 ? "mobile-sub-active" : ""}`}>
              <li className="mn-sub-multi" style={{ maxWidth: '200px', marginLeft: '-30%', display: 'flex', flexDirection: 'column' }}>
                <ul>
                  {HomeHeaderData.products.items.map((product, index) => (
                    <li key={index} onMouseEnter={() => setSelectedProduct(product)}>
                      <a href={product.link} aria-label={product.title} className="btn btn-round mb-xs-10 hover-effect" style={{ whiteSpace: 'nowrap' }}>
                        {product.hoverText}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
              {!isMobile &&
                <>
                  <li className="mn-sub-multi" style={{ minWidth: '350px', marginLeft: '-30%', display: 'flex', flexDirection: 'column' }}>
                    <span className="mn-group-title">&nbsp;</span>
                    <ul>
                      <li className="!min-w-[350px] !ml-[-30%] flex flex-col ">
                        <p className="menu-heading" style={{ color: 'var(--color-gray-light-5)' }}>
                          {selectedProduct?.title}
                        </p>
                        <p className="sec-text pb-3 !min-w-fit" style={{ color: 'var(--color-gray-light-5)', textAlign: 'left', padding: "10px" }}>
                          {selectedProduct?.description}
                        </p>
                      </li>
                    </ul>
                  </li>

                  <li className="mn-sub-multi" style={{ minWidth: '350px', marginLeft: '-30%', display: 'flex', flexDirection: 'column' }}>
                    <ul>
                      <li className="!min-w-[350px] !ml-[-30%] flex flex-col ">
                        <img src={selectedProduct?.image} className="pt-5 pb-2 rounded-md w-screen" alt={selectedProduct?.title} />
                      </li>
                    </ul>
                  </li>
                </>
              }
            </ul>
          </li>

          {/* Resource */}
          {HomeHeaderData.resources?.length > 0 && (
            <li className={menuOpen[3] === 3 ? "js-opened" : ""}>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); toggleParent(3, 3); }}
                className="mn-has-sub"
                aria-label="Resources"
              >
                Resources <i className="mi-chevron-down" />
              </a>

              <ul className={`mn-sub mn-has-multi ${menuOpen[3] === 3 ? "mobile-sub-active" : ""}`}>
                {HomeHeaderData.resources.map((resource, rIndex) => (
                  <li
                    key={rIndex}
                    className="mn-sub-multi"
                    style={{ minWidth: "250px", marginLeft: "-30%", display: "flex", flexDirection: "column" }}
                  >
                    <ul>
                      {resource.subItems?.map((subItem, index) => (
                        <li key={index}>
                          <a href={subItem.link} aria-label={subItem.ariaLabel}>
                            {subItem.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </li>
          )}

          {/* SOLUTIONS DROPDOWN */}
          <li className={menuOpen[2] === 1 ? "js-opened" : ""}>
            <a href="#" onClick={() => toggleParent(2, 1)} className="mn-has-sub" aria-label="Solutions">
              {HomeHeaderData.solutions.title} <i className="mi-chevron-down" />
            </a>
            <ul className={`mn-sub mn-has-multi ${menuOpen[2] === 1 ? "mobile-sub-active" : ""}`}>
              {HomeHeaderData.solutions.items.map((solution, index) => (
                <li key={index}>
                  <a href={solution.link} aria-label={solution.title}>{solution.title}</a>
                </li>
              ))}
            </ul>
          </li>

          {/* STATIC LINKS */}
          {HomeHeaderData.otherlinks.map((link, index) => (
            <li key={index}>
              <a href={link.href} aria-label={link.text}>{link.text}</a>
            </li>
          ))}
        </ul>

        <ul className="items-end clearlist">
          <li>
            <a href={HomeHeaderData.cta.cta_link} className="opacity-1 contact-link" aria-label={HomeHeaderData.cta.cta_name}>
              <span className={HomeHeaderData.cta.cta_class}>
                <span data-btn-animate="y">{HomeHeaderData.cta.cta_name}</span>
              </span>
            </a>
          </li>
        </ul>
      </div>


    </div>
  );
}
